module.exports = __webpack_public_path__ + "img/05529929000399.02157579.png";